import { useInfiniteQuery } from 'react-query';

import { useSelectedAssetId } from 'src/Hooks/Shared/useSelectedAssetId';
import { communityFeedApi } from 'src/Services/API';

/** Albums photos (POST_MEMORY) du bien courant. */
const useFetchCommunityFeedMemories = () => {
  const assetId = useSelectedAssetId();

  return useInfiniteQuery({
    queryKey: ['community-feed', assetId, 'memories'],
    queryFn: async ({ pageParam = null }) => {
      return (await communityFeedApi.communityFeedControllerMemories(assetId!, 10, pageParam)).data;
    },
    enabled: !!assetId,
    getNextPageParam: lastPage => lastPage.endCursor ?? undefined,

    // Refresh the feed every minutes so we are up to date
    cacheTime: 1 * 60 * 1000,
    // We use a very low stale time : 5 seconds. If the user goes away (in its dashboard to perform actions) and go back,
    // the short stale time of 5 seconds allow to refetch the new values and display an up to date dashboard.
    staleTime: 5 * 1000,
  });
};

export default useFetchCommunityFeedMemories;
